import type { TextLevel } from "../../../../../../mads/Text/TextLevel";
import type { TextStyle } from "react-native";

import { Heading } from "../../../../../../mads";

import { colors } from "@indeed/ifl-tokens";
import React from "react";

export interface JobTitleProps {
  jobTitle: string;
  level?: TextLevel;
}

const jobTitleStyle: TextStyle = {
  marginTop: 0,
  color: colors.neutral["1000"],
  marginBottom: 8,
};

/**
 * This is the simplified jobtitle without company logo
 */
export function JobTitle(props: JobTitleProps) {
  return (
    <Heading level={props.level} sx={jobTitleStyle} testID="vj-job-title">
      {props.jobTitle}
    </Heading>
  );
}
